import React, { useEffect, useState } from "react";
import { FormSection } from "../../common/FormCompany/FormSection";
import { Box } from "@mui/material";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { useGetCitiesQuery } from "../../api/user/modificaProfiloApi";
//import { useGetAtecoCodeQuery} from "../../api/admin/adminCompany";

import { toast } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { t } from "i18next";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";
import AssociateTableUserCompany from "./AssociateTableUserCompany";
import { useLocation, useNavigate } from "react-router-dom";
import { useDoEditProfileMutation } from "../../api/user/modificaProfiloApi";

export const FormUserCompany = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState();
  const [aziendaData, setAziendaData] = useState({
    id: "",
    anagrafeCode: "",
    name: "",
    vat: null,
    fiscalCode: "",
    address: "",
    houseNumber: "",
    postalCode: "",
    phoneNumber: "",
    email: "",
    pecLegale: "",
    opAddress: "",
    opHouseNumber: "",
    opPostalCode: "",
    opPhoneNumber: "",
    opEmail: "",
    nomeRef: "",
    cognomeRef: "",
    studioRef: undefined,
    operatorRef: "",
    multipleUser: [],
    atecoCodeId: null,
    codiceAtecoDescription: "",
    servicesId: [],
  });

  const [isEqualHeadquarters, setIsEqualHeadquarters] = useState(true);

  const [doEditProfile, { isLoading: isLoadingSave }] =
    useDoEditProfileMutation();

  // const { data } = useGetAtecoCodeQuery();

  useEffect(() => {
    if (location) {
      setAziendaData({
        ...location.state.companyToEdit,
        comuneLegale: location?.state?.companyToEdit?.city,
        comuneOperativo: location?.state?.companyToEdit?.opCity,
      });
      setFormData({
        name: location?.state?.companyToEdit?.users[0].name,
        email: location?.state?.companyToEdit?.users[0].email,
        adminId: location?.state?.companyToEdit?.users[0].adminId,
      });
    }
  }, [location]);

  // const atecoOptions =
  //   (data &&
  //     data.Data &&
  //     data.Data.map((el) => ({
  //       label: el?.code,
  //       value: el?.id,
  //     }))) ||
  //   [];

  const handleInputChange = (e) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? checked : e.target.value;
    // setValidationErrors((prevErrors) => ({
    //   ...prevErrors,
    //   [name]: "",
    // }));
    setAziendaData({
      ...aziendaData,
      [name]: value,
    });
  };

  const handleInputChangeAuto = (event, newValue) => {
    setAziendaData((prevData) => ({
      ...prevData,
      comuneLegale: {
        name: newValue ? newValue.name : "",
        cadastralCode: newValue ? newValue.cadastralCode : "",
      },
    }));
  };

  const handleInputChangeAutoOp = (event, newValue) => {
    setAziendaData((prevData) => ({
      ...prevData,
      comuneOperativo: {
        name: newValue ? newValue.name : "",
        cadastralCode: newValue ? newValue.cadastralCode : "",
      },
    }));
  };

  const handleSubmit = () => {
    const userData = {
      name: formData.name,
      email: formData.email,
      adminId: formData.adminId,
      isCompany: true,
    };

    const operationalHeadquarter = isEqualHeadquarters
      ? {
          opAddress: aziendaData.address,
          opHouseNumber: aziendaData.houseNumber,
          opPostalCode: aziendaData.postalCode,
          opPhoneNumber: aziendaData.phoneNumber,
          opEmail: aziendaData.email,
        }
      : {};
    const body = {
      ...aziendaData,
      ...operationalHeadquarter,
      cityId: aziendaData?.comuneLegale?.cadastralCode,
      opCityId: isEqualHeadquarters
        ? aziendaData?.comuneLegale?.cadastralCode
        : aziendaData?.comuneOperativo?.cadastralCode,
    };

    const { city, opCity, comuneLegale, comuneOperativo, ...clearBody } = body;
    userData.company = clearBody;
    userData.userCompanyId = aziendaData.id;

    doEditProfile(userData)
      .then((res) => {
        if (res?.data?.Result !== 1) {
          toast.error(res?.data?.Exception || t("CompanyNotUpdated"));
          return;
        }
        toast.success(t("CompanyUpdated"));
      })
      .catch(() => toast.error(t("CompanyNotUpdated")));

    navigate(-1);
  };

  return (
    <div className="flex flex-col">
      <div className="flex justify-center w-full items-center">
        <CoreBack />
        <div className="w-11/12 flex items-center justify-between">
          <h2 className="font-bold">{t("Edit") + " " + t("Company")}</h2>
        </div>
      </div>

      <AssociateTableUserCompany
        userData={location?.state?.companyToEdit?.users}
      />

      <div className="flex space-x-8 mt-10">
        <FormSection
          title="DATI AZIENDA"
          fields={[
            {
              label: t("CompanyCode"),
              name: "anagrafeCode",
              type: "text",
              value: aziendaData.anagrafeCode,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.anagrafeCode,
              className: "w-1/2 mt-2",
            },
            {
              label: t("CompanyName"),
              name: "name",
              type: "text",
              value: aziendaData.name,
              onChange: handleInputChange,
              required: true,
              // error: validationErrors.name,
              className: "w-1/2 mt-2",
            },
            {
              label: t("VAT"),
              name: "vat",
              type: "text",
              value: aziendaData.vat,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.vat,
              className: "w-1/2 mt-2",
            },
            {
              label: t("CF"),
              name: "fiscalCode",
              type: "text",
              value: aziendaData.fiscalCode,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.fiscalCode,
              className: "w-1/2 mt-2",
            },
          ]}
        />
        <FormSection
          title={t("Title2")}
          fields={[
            {
              label: t("CompanyStreet"),
              name: "address",
              type: "text",
              value: aziendaData.address,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.address,
              className: "w-1/2 mt-2",
            },
            {
              label: t("CompanyStreetNumber"),
              name: "houseNumber",
              type: "text",
              value: aziendaData.houseNumber,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.houseNumber,
              className: "w-1/2 mt-2",
            },
            {
              label: t("City"),
              name: "comuneLegale",
              type: "select",
              value: aziendaData?.comuneLegale?.name,
              fetch: useGetCitiesQuery,
              onChange: handleInputChangeAuto,
              required: false,
              // error: validationErrors.comuneLegale,
              className: "w-1/2 mt-4",
            },
            {
              label: t("PostalCode"),
              name: "postalCode",
              type: "text",
              value: aziendaData.postalCode,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.postalCode,
              className: "w-1/2 mt-2",
            },
            {
              label: t("Phone"),
              name: "phoneNumber",
              type: "text",
              value: aziendaData.phoneNumber,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.phoneNumber,
              className: "w-1/2 mt-2",
            },
            {
              label: "Email",
              name: "email",
              type: "email",
              value: aziendaData.email,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.email,
              className: "w-1/2 mt-2",
            },
            {
              label: t("Pec"),
              name: "pecLegale",
              type: "text",
              value: aziendaData.pecLegale,
              onChange: handleInputChange,
              required: false,
              // error: validationErrors.pecLegale,
              className: "w-1/2 mt-2",
            },
            { name: "emptyDiv", type: "emptyDiv", className: "w-1/2 mt-2" },
          ].filter((e) => {
            if (["emptyDiv", "email"].includes(e.name)) return false;
            return true;
          })}
        />
      </div>
      <div className="flex space-x-8 mt-10">
        <FormSection
          title={t("Title3")}
          isEqualHeadquartersCheckbox={
            <FormControlLabel
              control={
                <Checkbox
                  checked={isEqualHeadquarters}
                  onChange={() => setIsEqualHeadquarters((prev) => !prev)}
                />
              }
              label={t("HeadquarterMatch")}
            />
          }
          fields={
            isEqualHeadquarters
              ? []
              : [
                  {
                    label: t("CompanyStreet"),
                    name: "opAddress",
                    type: "text",
                    value: aziendaData.opAddress,
                    onChange: handleInputChange,
                    required: false,
                    //error: validationErrors.opAddress,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: t("CompanyStreetNumber"),
                    name: "opHouseNumber",
                    type: "text",
                    value: aziendaData.opHouseNumber,
                    onChange: handleInputChange,
                    required: false,
                    //error: validationErrors.opHouseNumber,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: t("City"),
                    name: "comuneOperativo",
                    type: "select",
                    value: aziendaData?.comuneOperativo?.name,
                    fetch: useGetCitiesQuery,
                    onChange: handleInputChangeAutoOp,
                    required: false,
                    //error: validationErrors.comuneOperativo,
                    className: "w-1/2 mt-4",
                  },
                  {
                    label: t("PostalCode"),
                    name: "opPostalCode",
                    type: "text",
                    value: aziendaData.opPostalCode,
                    onChange: handleInputChange,
                    required: false,
                    //error: validationErrors.opPostalCode,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: t("Phone"),
                    name: "opPhoneNumber",
                    type: "text",
                    value: aziendaData.opPhoneNumber,
                    onChange: handleInputChange,
                    required: false,
                    //error: validationErrors.opPhoneNumber,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: "Email",
                    name: "opEmail",
                    type: "email",
                    value: aziendaData.opEmail,
                    onChange: handleInputChange,
                    required: false,
                    //error: validationErrors.opEmail,
                    className: "w-1/2 mt-2",
                  },
                ]
          }
        />
        <FormSection
          title={t("Title5")}
          fields={[
            {
              disabled: true,
              label: t("AtecoCode"),
              name: "atecoCodeId",
              type: "coreSelectObjArr",
              value: aziendaData?.atecoCodeId,
              // items: [{ label: "Nessuno", value: null }, ...atecoOptions],
              onChange: handleInputChange,
              required: false,
              //error: validationErrors.atecoCodeId,
            },
            {
              disabled: true,
              label: t("AtecoDescription"),
              type: "text",
              name: "codiceAtecoDescription",
              // value: !aziendaData.atecoCodeId
              //   ? ""
              //   : aziendaData.codiceAtecoDescription ||
              //     data?.Data?.find((e) => e.id === aziendaData.atecoCodeId)
              //       ?.description,
              className: "w-1/2 mt-2",
            },
          ]}
        />
      </div>

      <Box
        sx={{
          width: "100%",
          textAlign: "left",
        }}
      >
        <div className="flex w-full justify-around mt-8">
          <CoreButton
            testo={t("Save")}
            className="btn-round"
            onClick={handleSubmit}
            disabled={isLoadingSave}
          />
        </div>
      </Box>
    </div>
  );
};
